import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {
  setSQFTActiveButton,
  setSQFTActiveSubMenuButton, setSQFTMenuOpened,
} from "../../../../../../../../actions/sqftMenuFunctions";
import {SIDEBAR_HIDDEN_BUTTONS} from "../../../../../../constants";
import PropTypes from "prop-types";
import FreeDraw from "../../../../../canvas/core/controls/freeDraw";

const SqftNavBacksplashesFreeDrawButton = (props) => {
  const { selectedBacksplash, setSelectedBacksplash, setSQFTActiveSubMenuButton, setSQFTActiveButton, setSQFTMenuOpened } = props;

  const handleClick = (e) => {
    void e;
    setSelectedBacksplash(SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw);
    setSQFTActiveSubMenuButton(SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw);

    setSQFTActiveButton(SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw);
    setSQFTMenuOpened(SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw);
    FreeDraw.init();
  };

  return (
    <li className={"lightbox-option-round lightbox-option-round--edge button--freeDraw" + ( selectedBacksplash === SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw ? "lightbox-option-selected" : "" )}
        onClick={handleClick}>
      <div className="lightbox-option-round-loader-edge lightbox-option-round-loader-freeDraw"/>
      <div className="lightbox-description-text lightbox-description-text--edge">
        <FormattedMessage id={"sqft.navigation.submenu.freeDraw"}/>
      </div>
    </li>
  )
};

SqftNavBacksplashesFreeDrawButton.propTypes = {
  selectedBacksplash: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedBacksplash: PropTypes.func,
};

const mapStateToProps = (store) => ({
  updateCalculations: store.sqftState.updateCalculations,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setSQFTActiveSubMenuButton,
  setSQFTActiveButton,
  setSQFTMenuOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavBacksplashesFreeDrawButton)
);
